<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div class="body-2">{{labels.quoteInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.product" v-model="travelForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" v-validate="'required'" @input="doProduct"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="tripTypeList" v-model="travelForm.tripType" :label="labels.tripType" item-text="label" item-value="value" data-vv-name="tripType" :data-vv-as="labels.tripType" :error-messages="errors.collect('tripType')" v-validate="'required'" @input="doTripType"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.travelArea" v-model="travelForm.travelArea" :label="labels.travelArea" item-text="label" item-value="value" data-vv-name="travelArea" :data-vv-as="labels.travelArea" :error-messages="errors.collect('travelArea')" v-validate="'required'" :loading="travelAreaLoading" prepend-icon="mdi-earth">
                <v-icon color="info" @click="countriesPnl = true" v-text="'mdi-magnify'" slot="append-outer"></v-icon>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <transition name="slide-y-transition" mode="out-in">
        <div v-if="countriesPnl">
          <v-divider></v-divider>
          <v-card-title>
            <v-icon>mdi-earth</v-icon>
            <div class="body-2 ml-1">{{labels.countriesTitle}}</div>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="countriesPnl = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete box :items="quoteParam.countries" v-model="countries" :label="labels.countries" item-text="label" item-value="value" data-vv-name="countries" :data-vv-as="labels.countries" :error-messages="errors.collect('countries')" multiple chips :persistent-hint="true" :hint="countriesLocator" deletable-chips :loading="travelAreaLoading" @input="doCountries"></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout justify-end align-end>
                <v-btn color="error" flat="flat" @click.native="countriesPnl = false">Cancel</v-btn>
                <v-btn color="primary" flat="flat" @click.native="doSelectCountries">Select</v-btn>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
        </div>
      </transition>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field v-int-mask="{intScale: 3}" v-model="travelForm.noAdult" :label="labels.noAdult" type="tel" :error-messages="errors.collect('noAdult')" data-vv-name="noAdult" :data-vv-as="labels.noAdult" v-validate="'required|numeric|max_value:999|min_value:0'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-int-mask="{intScale: 3}" v-model="travelForm.noChild" :label="labels.noChild" type="tel" :error-messages="errors.collect('noChild')" data-vv-name="noChild" :data-vv-as="labels.noChild" v-validate="'required|numeric|max_value:999|min_value:0'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs7 v-if="isStaff">
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['travelQuoteAcceptDate'])" @input="doAcceptDate" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required|accept_today_date'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['travelQuoteAcceptDate'])" @input="doAcceptDate" :max="minStartDate"></cal-picker-->
                </v-flex>
                 <v-flex xs7 v-else>
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['travelQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['travelQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="minStartDate"></cal-picker-->
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="acceptTime" :label="labels.acceptTime" v-validate="'required'" :data-vv-as="labels.acceptTime" data-vv-name="acceptTime" :error-messages="errors.collect('acceptTime')" :readonly="!checkAccess(['travelQuoteAcceptDate'])" @input="doAcceptDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="travelForm.startDate" :label="labels.startDate" v-validate="startDateValidation" :data-vv-as="labels.startDate" data-vv-name="startDate" :error-messages="errors.collect('startDate')" @input="doStartDate" :min="this.acceptDate" :max="maxStartDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="travelForm.endDate" :label="labels.endDate" v-validate="endDateValidation" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" :min="this.travelForm.startDate" :disabled="travelForm.tripType === 'A'" :hint="daysCoverage" :max="maxEndDate"></cal-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card v-if="quoteParam.discLdg.length > 0" class="mt-3">
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex md6 xs12>
              <v-autocomplete v-model="tempAddDiscLdg" :items="addDiscLdgList" label="Add Loadings" item-text="discLdgDesc" item-value="discLdg" prepend-icon="mdi-playlist-plus" outline clearable @change="doAddDiscLdg"></v-autocomplete>
            </v-flex>
            <v-flex md6 xs12></v-flex>
            <v-flex xs12 v-for="discLdg in removeDiscLdgList" :key="discLdg.discLdg">
              <v-checkbox v-model="travelForm.discLdg" :label="discLdg.discLdgDesc" :value="discLdg.discLdg" hide-details></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div class="body-2">{{labels.cpInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.campaign" v-model="travelForm.campaign" :label="labels.campaign" item-text="label" item-value="value" data-vv-name="campaign" :data-vv-as="labels.campaign" :error-messages="errors.collect('campaign')" clearable :loading="campaignLoading" @input="doCampaign"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.promotion" v-model="travelForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable :loading="promotionLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import clone from 'clone'
import toDate from 'date-fns/toDate'
import addYears from 'date-fns/addYears'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import differenceInDays from 'date-fns/differenceInDays'
import isAfter from 'date-fns/isAfter'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_TRAVEL_PARAM_GENERAL, QUOTE_TRAVEL_PARAM } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { tripType } from '@/const/underwriting/travel'
import { extractRecord } from '@/utils/extract'
import { formatDisplayTime, removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        quoteInfo: 'Quotation Information',
        product: 'Product*',
        tripType: 'Trip Type*',
        travelArea: 'Geographical Area*',
        countriesTitle: 'Geographical Area Locator',
        countries: 'Destination Country',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        noAdult: 'No. of Adult(s)*',
        noChild: 'No. of Child(ren)*',
        startDate: 'Start Date*',
        endDate: 'End Date*',
        cpInfo: 'Campaign/Promotion',
        campaign: 'Campaign',
        promotion: 'Promotion',
        discLdg: 'Loadings'
      },
      travelForm: {
        product: undefined,
        tripType: undefined,
        travelArea: undefined,
        acceptDate: undefined,
        noAdult: undefined,
        noChild: undefined,
        startDate: undefined,
        endDate: undefined,
        campaign: undefined,
        promotion: undefined,
        discLdg: []
      },
      countriesPnl: false,
      countries: [],
      resolveRegion: undefined,
      acceptDate: undefined,
      acceptTime: undefined,
      travelAreaLoading: false,
      campaignLoading: false,
      promotionLoading: false,
      discLdgLoading: false,
      tempAddDiscLdg: null
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    globalForm() {
      return this.$store.state.agency.quotation.travelForm
    },
    quoteParam() {
      return this.$store.state.agency.quotation.travelParam
    },
    isStaff() {
      return this.$store.state.agency.quotationSettings.isStaff
    },
    tripTypeList() {
      let result = []
      Object.keys(tripType).forEach(function (key) {
        const status = tripType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    selectedProduct() {
      if (this.travelForm.product) {
        return extractRecord(this.quoteParam.product, this.travelForm.product)
      } else {
        return null
      }
    },
    backDateDays() {
      const product = this.selectedProduct
      if (product) {
        return product.backDateAcceptDays
      } else {
        return null
      }
    },
    backDateLimit() {
      if (this.backDateDays !== null || this.backDateDays !== undefined) {
        if (this.backDateDays === 0) {
          return new Date()
        } else {
          return subDays(new Date(), this.backDateDays)
        }
      } else return null
    },
    acceptDateValidation() {
      // const result = 'required|accept_back_date:' + this.backDateDays + '|accept_start_date:' + this.travelForm.startDate + '|accept_today_date'
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_today_date'
      return 'required|accept_back_date:' + this.backDateDays
    },
    countriesLocator() {
      if (this.countries.length > 0) {
        if (this.resolveRegion) {
          const resolveParam = extractRecord(this.quoteParam.travelArea, this.resolveRegion)
          if (resolveParam) {
            return 'Geographical Area: ' + resolveParam.label
          } else {
            return 'System unable to resolve Region. Code: 100.'
          }
        } else {
          return 'System unable to resolve Region. Code: 101.'
        }
      } else {
        return 'You may select more than 1 Country. The furthest Region will be displayed.'
      }
    },
    daysBeforeCover() {
      if (this.travelForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.travelForm.product)
        if (productParam) {
          return productParam.maxDaysBeforeCover
        }
      }
      return undefined
    },
    minStartDate() {
      return new Date()
    },
    maxStartDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    startDateValidation() {
      // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'required|start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    },
    endDateValidation() {
      return 'required|start_enddate:' + this.travelForm.startDate + '|quote_travel_covered:' + this.travelForm.tripType + ',' + this.travelForm.startDate + ',' + this.maxDaysCovered
    },
    daysCoverage() {
      if (this.travelForm.startDate && this.travelForm.endDate) {
        return 'Days Covered: ' + (differenceInDays(toDate(this.travelForm.endDate), toDate(this.travelForm.startDate)) + 1)
      } else {
        return undefined
      }
    },
    maxDaysCovered() {
      if (this.travelForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.travelForm.product)
        if (productParam) {
          return productParam.maxDaysCovered
        }
      }
      return undefined
    },
    maxEndDate() {
      if (this.travelForm.tripType === 'S' && this.travelForm.startDate && this.maxDaysCovered !== undefined) {
        let result = removeTime(toDate(this.travelForm.startDate))
        result = addDays(result, (this.maxDaysCovered - 1))
        return result
      } else {
        return undefined
      }
    },
    proceedLoading() {
      if (this.travelAreaLoading || this.campaignLoading || this.promotionLoading || this.discLdgLoading) {
        return true
      } else {
        return false
      }
    },
    addDiscLdgList() {
      const addDiscLdgParam = this.quoteParam.discLdg
      if (addDiscLdgParam && addDiscLdgParam.length > 0) {
        let result = []
        for (let discLdg of addDiscLdgParam) {
          // Check if its already inside DiscLdgForm
          if (this.travelForm.discLdg.length > 0) {
            if (!this.travelForm.discLdg.find(a => a === discLdg.discLdg)) {
              result.push(discLdg)
            }
          } else {
            result.push(discLdg)
          }
        }
        return result
      }
      return []
    },
    removeDiscLdgList() {
      const addDiscLdgParam = this.quoteParam.discLdg
      if (addDiscLdgParam && addDiscLdgParam.length > 0) {
        let result = []
        for (let discLdg of addDiscLdgParam) {
          // Check if its already inside DiscLdgForm
          if (this.travelForm.discLdg.length > 0) {
            if (this.travelForm.discLdg.find(a => a === discLdg.discLdg)) {
              result.push(discLdg)
            }
          }
        }
        return result
      }
      return []
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.travelForm.product = this.globalCommonForm.product
      this.travelForm.tripType = this.globalForm.tripType
      this.travelForm.travelArea = this.globalForm.travelArea
      this.travelForm.noAdult = this.globalForm.noAdult
      this.travelForm.noChild = this.globalForm.noChild
      this.travelForm.startDate = this.globalCommonForm.startDate
      this.travelForm.endDate = this.globalCommonForm.endDate
      this.travelForm.acceptDate = this.globalCommonForm.acceptDate
      this.travelForm.campaign = this.globalCommonForm.campaign
      this.travelForm.promotion = this.globalCommonForm.promotion
      if (this.globalCommonForm.discLdg && this.globalCommonForm.discLdg.length > 0) {
        this.$set(this.travelForm, 'discLdg', clone(this.globalCommonForm.discLdg))
      }

      // Need break down acceptDate into date and time for input
      if (this.travelForm.acceptDate) {
        this.acceptDate = this.travelForm.acceptDate
        this.acceptTime = formatDisplayTime(this.travelForm.acceptDate)
      }

      // Flag to determine whether to run snowball method
      let doParams = false

      if (!this.travelForm.product) {
        if (this.quoteParam.product && this.quoteParam.product.length > 0) {
          // This is to load 1st value if its a fresh quotation
          this.travelForm.product = this.quoteParam.product[0].value
          doParams = true
        }
      } else {
        if (!this.quoteParam.generalLoaded) {
          doParams = true
        }
      }

      // Other defaults
      if (!this.travelForm.tripType && this.tripTypeList && this.tripTypeList.length > 0) {
        this.travelForm.tripType = this.tripTypeList[0].value
      }
      if (this.travelForm.noAdult === null) {
        this.travelForm.noAdult = 0
      }
      if (this.travelForm.noChild === null) {
        this.travelForm.noChild = 0
      }

      if (doParams) {
        this.doProduct()

        // Need to do after doProduct (maxDaysCovered and stuff)
        // Start and End Date
        if (!this.travelForm.startDate) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          this.travelForm.startDate = today
          this.doStartDate()
        }
        this.$store.commit(QUOTE_TRAVEL_PARAM_GENERAL)
      }
    },
    doProduct() {
      if (this.travelForm.tripType && this.travelForm.product) {
        this.getArea()
      } else {
        this.travelForm.travelArea = undefined
      }
      if (this.travelForm.acceptDate && this.travelForm.product) {
        this.getCampaign()
      } else {
        this.travelForm.campaign = undefined
        this.doCampaign()
      }

      if (this.travelForm.product) {
        this.getDiscLdg()
      } else {
        this.travelForm.discLdg = []
      }
    },
    doTripType() {
      if (this.travelForm.product && this.travelForm.tripType) {
        this.getArea()
        this.doStartDate()
      } else {
        this.travelForm.travelArea = undefined
        this.doStartDate()
      }
    },
    async getArea() {
      const apiURI = this.$store.state.agency.quotation.menu.area
      if (apiURI) {
        try {
          const expand = {
            product: this.travelForm.product,
            tripType: this.travelForm.tripType
          }
          this.travelAreaLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              travelArea: data.travelArea,
              countries: data.countries,
              ignoreValue: true
            }
            this.$store.commit(QUOTE_TRAVEL_PARAM, commitResult)
          }
          this.travelAreaLoading = false

          if (this.travelForm.travelArea && this.quoteParam.travelArea && this.quoteParam.travelArea.length > 0) {
            // Check if the current travelArea value is still valid
            let travelAreaIsValid = false
            for (var i = 0; i < this.quoteParam.travelArea.length; i++) {
              const travelArea = this.quoteParam.travelArea[i]
              if (travelArea.value === this.travelForm.travelArea) {
                travelAreaIsValid = true
                break
              }
            }
            // Invalid TravelArea (reset to undefined)
            if (!travelAreaIsValid) {
              this.travelForm.travelArea = undefined
            }
          } else {
            this.travelForm.travelArea = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.travelAreaLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCountries() {
      if (this.countries.length > 0) {
        let selectedRegion = []
        this.resolveRegion = undefined
        for (const country of this.countries) {
          const countryParam = this.quoteParam.countries.find(a => a.value === country)
          if (countryParam && countryParam.secondaryValue) {
            if (selectedRegion.indexOf(countryParam.secondaryValue) === -1) {
              selectedRegion.push(countryParam.secondaryValue)
            }
          }
        }
        if (selectedRegion.length > 0) {
          if (selectedRegion.length === 1) {
            this.resolveRegion = selectedRegion[0]
          } else {
            // Find the furthest region here
            let resolveRegions = []
            for (const region of selectedRegion) {
              const param = extractRecord(this.quoteParam.travelArea, region)
              if (param) {
                resolveRegions.push(param)
              }
            }
            let result
            let rank = 0
            if (resolveRegions.length > 0) {
              for (const region of resolveRegions) {
                if (!result) {
                  result = region.value
                  rank = region.secondaryValue
                } else {
                  if (region.secondaryValue > rank) {
                    result = region.value
                    rank = region.secondaryValue
                  }
                }
              }
            }
            this.resolveRegion = result
          }
        }
      }
    },
    doSelectCountries() {
      this.travelForm.travelArea = this.resolveRegion
      this.countriesPnl = false
    },
    doStartDate() {
      if (this.travelForm.startDate) {
        if (this.travelForm.tripType === 'A') {
          // Add 1 year to end Date
          let endDate = addYears(this.travelForm.startDate, 1)
          endDate = subDays(endDate, 1)
          this.travelForm.endDate = endDate
        } else {
          this.travelForm.endDate = this.travelForm.startDate
        }
      } else {
        this.travelForm.endDate = null
      }
    },
    doAcceptDate() {
      // Format Accept Date
      if (this.checkAccess(['travelQuoteAcceptDate'])) {
        if (this.acceptDate && this.acceptTime && this.acceptTime.length === 5) {
          const hr = this.acceptTime.substring(0, 2)
          const min = this.acceptTime.substring(3, 5)
          this.acceptDate = toDate(this.acceptDate)
          this.acceptDate.setHours(hr)
          this.acceptDate.setMinutes(min)
          this.travelForm.acceptDate = this.acceptDate
        }
      }
      if (this.travelForm.product && this.travelForm.acceptDate) {
        this.getCampaign()
      } else {
        this.travelForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getCampaign() {
      const apiURI = this.$store.state.agency.quotation.menu.campaign
      if (apiURI) {
        try {
          const expand = {
            product: this.travelForm.product,
            intermediary: this.globalCommonForm.intermediary,
            acceptDate: formatDisplayDateTime2(this.travelForm.acceptDate)
          }
          this.campaignLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              campaign: data.data
            }
            this.$store.commit(QUOTE_TRAVEL_PARAM, commitResult)
          }
          this.campaignLoading = false

          if (this.travelForm.campaign && this.quoteParam.campaign && this.quoteParam.campaign.length > 0) {
            // Check if the current campaign value is still valid
            let campaignIsValid = false
            for (var i = 0; i < this.quoteParam.campaign.length; i++) {
              const campaign = this.quoteParam.campaign[i]
              if (campaign.value === this.travelForm.campaign) {
                campaignIsValid = true
                break
              }
            }
            // Invalid Campaign (reset to undefined)
            if (!campaignIsValid) {
              this.travelForm.campaign = undefined
            } else { }
          } else {
            this.travelForm.campaign = undefined
          }
          // Do campaign (get promotion)
          this.doCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.campaignLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCampaign() {
      if (this.travelForm.campaign && this.travelForm.acceptDate) {
        this.getPromotion()
      } else {
        this.travelForm.promotion = undefined
      }
    },
    async getPromotion() {
      const apiURI = this.$store.state.agency.quotation.menu.promotion
      if (apiURI) {
        try {
          const expand = {
            campaign: this.travelForm.campaign,
            acceptDate: formatDisplayDateTime2(this.travelForm.acceptDate)
          }
          this.promotionLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              promotion: data.data
            }
            this.$store.commit(QUOTE_TRAVEL_PARAM, commitResult)
          }
          this.promotionLoading = false

          if (this.travelForm.promotion && this.quoteParam.promotion && this.quoteParam.promotion.length > 0) {
            // Check if the current promotion value is still valid
            let promotionIsValid = false
            for (var i = 0; i < this.quoteParam.promotion.length; i++) {
              const promotion = this.quoteParam.promotion[i]
              if (promotion.value === this.travelForm.promotion) {
                promotionIsValid = true
                break
              }
            }
            // Invalid Promotion (reset to undefined)
            if (!promotionIsValid) {
              this.travelForm.promotion = undefined
            }
          } else {
            this.travelForm.promotion = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.promotionLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async getDiscLdg() {
      if (this.travelForm.product) {
        const apiURI = this.$store.state.agency.quotation.menu.discLdg
        if (apiURI) {
          try {
            this.discLdgLoading = true
            const expand = {
              product: this.travelForm.product
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result
              const commitResult = {
                discLdg: data.data
              }
              this.$store.commit(QUOTE_TRAVEL_PARAM, commitResult)
            }
            this.discLdgLoading = false

            if (this.travelForm.discLdg && this.travelForm.discLdg.length > 0 && this.quoteParam.discLdg && this.quoteParam.discLdg.length > 0) {
              // Check if the current discLdg value is still valid
              for (const discLdg of this.travelForm.discLdg) {
                let discLdgIsValid = false
                for (const discLdgParam of this.quoteParam.discLdg) {
                  if (discLdg === discLdgParam.discLdg) {
                    discLdgIsValid = true
                    break
                  }
                }
                if (!discLdgIsValid) {
                  // Invalid, Remove from form
                  this.travelForm.discLdg.splice(this.travelForm.discLdg.indexOf(this.travelForm.discLdg.find(x => x === discLdg)), 1)
                }
              }
            } else {
              this.travelForm.discLdg = []
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            this.discLdgLoading = false
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        this.travelForm.discLdg = []
        const commitResult = {
          discLdg: []
        }
        this.$store.commit(QUOTE_TRAVEL_PARAM, commitResult)
      }
    },
    doAddDiscLdg() {
      if (this.tempAddDiscLdg) {
        this.travelForm.discLdg.push(this.tempAddDiscLdg)
        this.tempAddDiscLdg = null
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Some form validation
          if ((this.travelForm.noAdult + this.travelForm.noChild) > 0) {
            if ((this.travelForm.campaign && this.travelForm.promotion) || (!this.travelForm.campaign && !this.travelForm.promotion)) {
              this.$store.dispatch('travelQuoteGeneral', this.travelForm)
              this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
              this.$router.push({ name: 'travelQuotePlans' })
            } else {
              this.errorMessage('Please select a promotion if this quotation is participating in a campaign')
              this.promptFieldCheck()
            }
          } else {
            this.errorMessage('Please select at least 1 Insured Person')
            this.promptFieldCheck()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('travelQuoteGeneral', this.travelForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  created() {
    // Load in local field validation
    // Name must be unique (as it will extend throughout the application)
    this.$validator.extend('quote_travel_covered', {
      getMessage(field, args) {
        if (args === void 0) args = [null, null, 0]
        return `Maximum duration for Single Trip is ${args[2]} day(s)`
      },
      validate(value, args) {
        if (args === void 0) args = [null, null, 0]
        const trip = args[0]
        let maxDate = args[1]
        const maxDays = Number(args[2])
        if (value && trip && maxDate && maxDays) {
          maxDate = addDays(removeTime(maxDate), (maxDays - 1))
          if (isAfter(removeTime(toDate(value)), maxDate)) return false
          else return true
        }
        return true
      }
    })
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss" scoped>
.loadingBox {
  max-width: 300px;
}
</style>
